import React, { useState, useEffect, useRef } from 'react'
import UserSelect from '../Expense/components/UserSelect';
import TransferTypeSB from './components/TransferTypeSB';
import useUserData from '../../hooks/useUserData';
import useTransferTypeData from '../../hooks/useTransactionTypeData';
import { FaSpinner } from "react-icons/fa";

import { useDispatch, useSelector } from 'react-redux';

import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";
import { useNavigate } from 'react-router-dom';

import { createTransferUtoUService } from "../../services/transfer.service";
import { selectUserData } from '../../reducers/user.reducer';


const UserToUser = () => {

    const [errors, setErrors] = useState({});

    const [expand, setExpand] = useState(false);
    const [expandTransferType, setExpandTransferType] = useState(false);
    const [isSubimtting, setIsSubmitting] = useState(false)
    const [user, setUser] = useState({ 'userId': '', 'name': 'Transfer To' });
    const [loginUser, setLoginUser] = useState({ 'userId': '', 'name': '' });
    const [transferType, setTransferType] = useState({'transactionTypeId': '', 'transactionType' : 'Transfer Type'});

    const [userData, setUserData] = useUserData([]);
    const [transferTypeData, setTransferTypeData] = useTransferTypeData([]);

    const [amount, setAmount] = useState(0);
    const [description, setDescription] = useState('');

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const inputRef = useRef(null);

    const handleFocus = () => {
        inputRef.current.select();
    };

    const loginUserData = useSelector(selectUserData);
    const handleWheel = (event) => event.target.blur();

    useEffect(() => {
        setLoginUser({
            userId: loginUserData?.userInfo?.userId,
            name: loginUserData?.userInfo?.name
        });
    }, [loginUserData]);

    const selectUser=(e)=>{
        e.stopPropagation();
        setExpand(!expand);
        setExpandTransferType(false);
    }

    const selectTransferType=(e)=>{
        e.stopPropagation();
        setExpandTransferType(!expandTransferType);
        setExpand(false);
    }


    let handleSubmit = async (event) => {
    
     event.preventDefault();
     try { 
        setIsSubmitting(true)
        const validateErrors = validate();
        if(Object.keys(validateErrors).length > 0) {
            return setErrors(validateErrors)
          } else {
            setErrors({})
        };

        setLoginUser({
            userId: loginUserData?.userInfo?.userId,
            name: loginUserData?.userInfo?.name
        });
 
        const result = await createTransferUtoUService({
                fromUserId: loginUserData?.userInfo?.userId,
                toUserId: user.userId,
                transactionTypeId: transferType.transactionTypeId,
                amount: parseInt(amount, 10),
                description: description
            });
        if(result.success) {
            dispatch(
                setToastMessage({
                    message: "Success",
                    type: "success",
                })
            );
            setTimeout(() => {
                navigate('/user-to-user-history');
            }, 1000)
        }

        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
            setIsSubmitting(false)
        }
       
    }

    const validate = () => {
        let errors = {};
        if(!user.userId) {
            errors.user = 'User is required';
        }else if(!transferType.transactionTypeId) {
            errors.transferType = 'Transfer Type is required';
        }else if(!amount) {
            errors.amount = 'Amount is required';
        }else if(!description) {
            errors.description = 'Description is required';
        }else if(user.userId === loginUser.userId) {
            errors.yourself = 'You cannot transfer to yourself';
            alert('You cannot transfer to yourself');
        }

        return errors;
    }

    // const createAction = async () => {
    //     // dispatch(setIsLoading(true))
    //      console.log("run")
    //     setLoginUser({
    //         userId: loginUserData?.userInfo?.userId,
    //         name: loginUserData?.userInfo?.name
    //     });

    //     try {
    //         let result;
    //         result = await createTransferUtoUService({
    //                 fromUserId: loginUser.userId,
    //                 toUserId: user.userId,
    //                 transactionTypeId: transferType.transactionTypeId,
    //                 amount: parseInt(amount, 10),
    //                 description: description
    //             });
    //             if(result) {
    //                 dispatch(
    //                     setToastMessage({
    //                         message: "Success",
    //                         type: "success",
    //                     })
    //                 );
    //                 setTimeout(() => {
    //                     navigate('/user-to-user-history');
    //                 }, 2000)
    //             }

    //     } catch (error) {
    //         const errorMessage =
    //             error?.response?.data?.error?.includes('streaming buffer')
    //                 ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
    //                 : error?.response?.data?.message || error?.message;

    //         dispatch(
    //             setToastMessage({
    //                 message: errorMessage,
    //                 type: "error",
    //             })
    //         );
    //     } finally {
    //         dispatch(setIsLoading(false))
    //     }
    // }

    return (
        <>
            <div>
                <div className='bg-white rounded-sm h-[87dvh] mx-2 my-2'>

                    <div className='w-64 h-[23%] flex justify-end items-end mx-auto'>

                    </div>

                    <form
                        className='flex flex-col gap-5 justify-center items-center h-[60%] w-64 mx-auto'
                        onSubmit={handleSubmit}
                    >

                            <UserSelect
                                user={user}
                                setUser={setUser}
                                selectUser={selectUser}
                                userData={userData}
                                setExpand={setExpand}
                                expand={expand}
                            />

                            {errors.user && <p className='text-red text-xs font-bold'>{errors.user}</p>}

                            <TransferTypeSB
                                transferType={transferType}
                                setTransferType={setTransferType}
                                selectTransferType={selectTransferType}
                                transferTypeData={transferTypeData}
                                setExpandTransferType={setExpandTransferType}
                                expandTransferType={expandTransferType}
                                shadow={true}

                            />
                            {errors.transferType && <p className='text-red text-xs font-bold'>{errors.transferType}</p>}


                            <input
                                type="number"
                                name='amount'
                                value={amount}
                                ref={inputRef}
                                onWheel={handleWheel}
                                onFocus={handleFocus}
                                className='bg-bgColor rounded-sm py-2 px-3 w-full outline-none text-end shadow-lg '
                                placeholder='Amount'
                                onChange={(e) => setAmount(e.target.value)}
                            />

                            {errors.amount && <p className='text-red text-xs font-bold'>{errors.amount}</p>}

                        <input
                            type="text"
                            name='description'
                            value={description}
                            className='bg-bgColor rounded-sm py-2 px-3  w-full outline-none shadow-lg '
                            placeholder='Description'
                            onChange={(e) => setDescription(e.target.value)}
                        />

                            {errors.description && <p className='text-red text-xs font-bold'>{errors.description}</p>}

                        <div className='w-full items-end  text-white font-semibold'>
                            <button type='submit' 
                                className='bg-buttonBlue rounded-sm py-2 w-32  shadow-lg'
                                disabled={isSubimtting}
                            >
                               {isSubimtting ?  <FaSpinner className="animate-spin text-2xl text-green-500" /> :"Save"}
                            </button>
                            {/* <button type='button' className='bg-buttonRed rounded-sm py-2 w-32'>Cancel</button> */}
                        </div>
                    </form>

                </div>
            </div>


        </>
    )
}

export default UserToUser
